import { Component, Input } from '@angular/core';
import { trackByValue } from '../../utils/track-by';
import { VexBreadcrumbComponent } from './vex-breadcrumb/vex-breadcrumb.component';
import { ActivatedRoute, NavigationEnd, Router, RouterLink } from '@angular/router';
import { NgFor } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs';

@Component({
  selector: 'vex-breadcrumbs',
  template: `
    <div class="pt-2 pb-8 flex flex-col items-start justify-center" style="margin-left: 40px; margin-right: 40px;">
      <div class="w-full">
        <h1 class="title mt-0 mb-1">
          {{ (breadcrumbs[breadcrumbs.length - 1]?.label ? (breadcrumbs[breadcrumbs.length - 1].label + '.TEXT') : '') | translate }}
        </h1>
      </div>

      <div class="flex items-center gap-2">
        <vex-breadcrumb>
          <a [routerLink]="['/']">
            <mat-icon svgIcon="mat:home" class="icon-sm"></mat-icon>
          </a>
        </vex-breadcrumb>

        <ng-container *ngFor="let breadcrumb of breadcrumbs; let last = last">
          <div class="w-1 h-1 bg-gray-600 rounded-full ltr:md:mr-2 rtl:md:ml-2"></div>
          <vex-breadcrumb>
            <span>{{ (breadcrumb.label + '.TEXT') | translate }}</span>
          </vex-breadcrumb>
        </ng-container>
      </div>
    </div>
  `,
  standalone: true,
  imports: [VexBreadcrumbComponent, RouterLink, NgFor, MatIconModule, TranslateModule]
})
export class VexBreadcrumbsComponent {
  breadcrumbs: Array<{ label: string, url: string }> = [];
  trimmedUrl:string='';

  constructor(private router: Router, private activatedRoute: ActivatedRoute, private translate: TranslateService) {}

  ngOnInit(): void {
    // Subscribe to router events to update breadcrumbs on navigation
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.breadcrumbs = this.createBreadcrumbs(this.activatedRoute.root);
    });

    // Watch for language change events
    this.translate.onLangChange.subscribe(() => {
      this.breadcrumbs = this.createBreadcrumbs(this.activatedRoute.root);
    });

    // Initialize breadcrumbs on component load
    this.breadcrumbs = this.createBreadcrumbs(this.activatedRoute.root);
  }

  private createBreadcrumbs(route: ActivatedRoute, url: string = '', breadcrumbs: Array<{ label: string, url: string }> = []): Array<{ label: string, url: string }> {
    const children: ActivatedRoute[] = route.children;

    if (children.length === 0) {
      return breadcrumbs;
    }

    for (const child of children) {
      const urlSegments = child.snapshot.url.map(segment => segment.path);

      const lastSegment = urlSegments[urlSegments.length - 1];

      // Check if the last segment is a number
      if (!isNaN(Number(lastSegment))) {
        // If it's a number, trim it from the URL
        this.trimmedUrl = urlSegments.slice(0, -1).join('/');
      } else {
        // If it's not a number, keep the whole URL as is
        this.trimmedUrl = urlSegments.join('/');
      }
      if (this.trimmedUrl !== '') {
        url += `/${this.trimmedUrl}`;
        breadcrumbs.push({ label: this.trimmedUrl.toUpperCase(), url });
      }
      return this.createBreadcrumbs(child, url, breadcrumbs);
    }

    return breadcrumbs;
  }
}
